import React, { useState, useRef, useEffect } from "react";
import { Button, Modal } from "antd";

const VideoPreviewModal = ({ videoUrl, isVisible, onClose, title }) => {
  const [isPlaying, setIsPlaying] = useState(true);
  const videoRef = useRef(null);
  const [currentVideoUrl, setCurrentVideoUrl] = useState(videoUrl);

  useEffect(() => {
    if (isVisible) {
      if (videoUrl !== currentVideoUrl) {
        setCurrentVideoUrl(videoUrl);
      }

      setTimeout(() => {
        if (videoRef.current) {
          videoRef.current.currentTime = 0;
          videoRef.current.load();
          videoRef.current.play().catch((e) => {
            setIsPlaying(false);
          });
          setIsPlaying(true);
        }
      }, 100);
    }
  }, [isVisible, videoUrl, currentVideoUrl]);

  // Cleanup when modal closes
  useEffect(() => {
    if (!isVisible && videoRef.current) {
      videoRef.current.pause();
      setIsPlaying(false);
    }
  }, [isVisible]);

  const handlePlayPause = () => {
    if (!videoRef.current) return;

    if (isPlaying) {
      videoRef.current.pause();
    } else {
      videoRef.current.play();
    }
    setIsPlaying(!isPlaying);
  };

  const handleFullscreen = () => {
    const video = videoRef.current;
    if (!video) return;

    if (video.requestFullscreen) video.requestFullscreen();
    else if (video.webkitRequestFullscreen) video.webkitRequestFullscreen();
    else if (video.msRequestFullscreen) video.msRequestFullscreen();
  };

  return (
    <Modal
      title={title || "Video Preview"}
      open={isVisible}
      onCancel={onClose}
      footer={null}
      width={800}
      centered
      afterClose={() => {
        if (videoRef.current) {
          videoRef.current.currentTime = 0;
          videoRef.current.pause();
        }
      }}
    >
      <div className="relative bg-black rounded-lg overflow-hidden">
        <video
          ref={videoRef}
          controls
          autoPlay
          muted
          className="w-full max-h-[70vh]"
          onPlay={() => setIsPlaying(true)}
          onPause={() => setIsPlaying(false)}
          key={videoUrl}
        >
          <source src={videoUrl} type="video/webm" />
          Your browser does not support the video tag.
        </video>
      </div>

      <div className="mt-4 text-right">
        <a href={videoUrl} target="_blank" rel="noopener noreferrer">
          Open in new tab
        </a>
      </div>
    </Modal>
  );
};

export default VideoPreviewModal;
